import { defineStore } from "pinia";
import { ref } from "vue";
import type { ServerSession } from "../domain/serverSession";

export const useServerSessionStore = defineStore('serverSession', () => {
  const id = ref<string>('');
  const started = ref<string>('');
  const version = ref<string>('');
  const initialized = ref<boolean>(false);
  const newVersion = ref<boolean>(false);
  const newSession = ref<boolean>(false);

  function merge(message: ServerSession) {
    id.value = message.id;

    if (initialized.value) {

      if (version.value !== message.version) {
        newVersion.value = true;
      }

      if (id.value !== message.id) {
        newSession.value = true;
      }
    }

    version.value = message.version;
    started.value = message.started;
    initialized.value = true;
  }

  return {
    id,
    version,
    started,
    newVersion,
    newSession,
    merge
  };
})
